var React = require('react');

function LineSecondLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#dae0e5","strokeWidth":"2","d":"m1,1l0,327.201717c55.758621,-0.332419 111.517243,-0.664838 167.275864,-0.997257l0,91.646121"}));
}

LineSecondLeft.defaultProps = {"height":"420","width":"170","viewBox":"0 0 170 420"};

module.exports = LineSecondLeft;

LineSecondLeft.default = LineSecondLeft;
